<template>
  <div class="horas-home">
    <div class="header">
      <div class="filters">
        <div class="filter-group">
          <label>Empleado</label>
          <select v-model="filtros.empleado">
            <option value="">Todos</option>
            <option v-for="emp in empleados" :key="emp.id" :value="emp.id">
              {{ emp.nombre }}
            </option>
          </select>
        </div>

        <div class="filter-group">
          <label>Desde</label>
          <input v-model="filtros.desde" type="date" />
        </div>

        <div class="filter-group">
          <label>Hasta</label>
          <input v-model="filtros.hasta" type="date" />
        </div>

        <label>
          <input v-model="filtros.sin_liquidar" type="checkbox" />
          Solo sin liquidar
        </label>

        <button class="btn-primary" @click="abrirModalCrear">
          Registrar Horas
        </button>
      </div>
    </div>

    <div v-if="cargando" class="loading">Cargando...</div>

    <table v-else class="horas-table">
      <thead>
        <tr>
          <th>Empleado</th>
          <th>Fecha</th>
          <th>Entrada</th>
          <th>Salida</th>
          <th>Horas</th>
          <th>Recargo</th>
          <th>Extra</th>
          <th>Liquidado</th>
          <th>Acciones</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="hora in horasFiltradas" :key="hora.id">
          <td>{{ hora.empleado_nombre }}</td>
          <td>{{ formatearFecha(hora.fecha) }}</td>
          <td>{{ hora.hora_entrada }}</td>
          <td>{{ hora.hora_salida }}</td>
          <td class="numero">{{ hora.horas }}</td>
          <td class="numero">{{ hora.recargo }}%</td>
          <td>{{ hora.es_extra ? 'Sí' : 'No' }}</td>
          <td>
            <span :class="['badge', hora.esta_liquidado ? 'liquidado' : 'pendiente']">
              {{ hora.esta_liquidado ? 'Liquidado' : 'Pendiente' }}
            </span>
          </td>
          <td class="acciones">
            <button
              v-if="!hora.esta_liquidado"
              class="btn-link"
              @click="editarHora(hora.id)"
            >
              Editar
            </button>
            <button
              v-if="!hora.esta_liquidado"
              class="btn-link"
              @click="eliminarHora(hora.id)"
            >
              Eliminar
            </button>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Modal crear/editar -->
    <div v-if="modalVisible" class="modal-overlay" @click="modalVisible = false">
      <div class="modal" @click.stop>
        <div class="modal-header">
          <h2>{{ editandoId ? 'Editar' : 'Registrar' }} Horas</h2>
          <button class="btn-close" @click="modalVisible = false">×</button>
        </div>

        <div class="modal-body">
          <form @submit.prevent="guardarHora">
            <div class="form-group">
              <label>Empleado *</label>
              <select v-model="form.empleado" required :disabled="editandoId">
                <option value="">Seleccionar empleado</option>
                <option v-for="emp in empleados" :key="emp.id" :value="emp.id">
                  {{ emp.nombre }}
                </option>
              </select>
            </div>

            <div class="form-group">
              <label>Fecha *</label>
              <input v-model="form.fecha" type="date" required />
            </div>

            <div class="form-row">
              <div class="form-group">
                <label>Hora Entrada *</label>
                <input v-model="form.hora_entrada" type="time" required />
              </div>

              <div class="form-group">
                <label>Hora Salida *</label>
                <input v-model="form.hora_salida" type="time" required />
              </div>
            </div>

            <div class="form-row">
              <div class="form-group">
                <label>Recargo (%)</label>
                <input v-model.number="form.recargo" type="number" min="0" />
              </div>

              <div class="form-group">
                <label>
                  <input v-model="form.es_extra" type="checkbox" />
                  Horas Extra
                </label>
              </div>
            </div>

            <div class="form-group">
              <label>Observaciones</label>
              <textarea v-model="form.observaciones"></textarea>
            </div>

            <div class="modal-footer">
              <button type="button" class="btn-secondary" @click="modalVisible = false">
                Cancelar
              </button>
              <button type="submit" class="btn-primary" :disabled="cargandoForm">
                {{ cargandoForm ? 'Guardando...' : 'Guardar' }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!-- Modal de error -->
    <div v-if="error" class="error-alert">
      <p>{{ error }}</p>
      <button @click="error = null">Cerrar</button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { getApiErrorMessage } from '@/util/apiError';
import { formatearFecha as fechaDeCalendario } from '@/util/fecha';
import SueldosAPI from '@/api/sueldos/sueldos';

export default {
  name: 'RegistroHorasHome',
  data() {
    return {
      cargando: false,
      cargandoForm: false,
      modalVisible: false,
      error: null,
      empleados: [],
      editandoId: null,
      filtros: {
        empleado: '',
        desde: '',
        hasta: '',
        sin_liquidar: true,
      },
      form: {
        empleado: '',
        fecha: '',
        hora_entrada: '',
        hora_salida: '',
        recargo: 0,
        es_extra: false,
        observaciones: '',
      },
    };
  },
  computed: {
    ...mapGetters('sueldos', ['horas', 'horasSinLiquidar']),
    horasFiltradas() {
      let lista = this.horas;

      if (this.filtros.sin_liquidar) {
        lista = lista.filter(h => !h.esta_liquidado);
      }

      if (this.filtros.empleado) {
        lista = lista.filter(h => h.empleado === parseInt(this.filtros.empleado));
      }

      if (this.filtros.desde) {
        lista = lista.filter(h => h.fecha >= this.filtros.desde);
      }

      if (this.filtros.hasta) {
        lista = lista.filter(h => h.fecha <= this.filtros.hasta);
      }

      return lista;
    },
  },
  methods: {
    ...mapActions('sueldos', [
      'fetchHoras',
      'crearHora',
      'actualizarHora',
      'eliminarHora',
      'fetchHora',
    ]),
    async cargarHoras() {
      this.cargando = true;
      try {
        const params = {
          sin_liquidar: this.filtros.sin_liquidar,
        };
        if (this.filtros.empleado) {
          params.empleado = this.filtros.empleado;
        }
        if (this.filtros.desde) {
          params.desde = this.filtros.desde;
        }
        if (this.filtros.hasta) {
          params.hasta = this.filtros.hasta;
        }
        await this.fetchHoras(params);
      } catch (err) {
        this.error = getApiErrorMessage(err);
      } finally {
        this.cargando = false;
      }
    },
    async cargarEmpleados() {
      try {
        this.empleados = await SueldosAPI.opciones.empleados();
      } catch (err) {
        this.error = getApiErrorMessage(err);
      }
    },
    abrirModalCrear() {
      this.editandoId = null;
      this.form = {
        empleado: '',
        fecha: new Date().toISOString().split('T')[0],
        hora_entrada: '',
        hora_salida: '',
        recargo: 0,
        es_extra: false,
        observaciones: '',
      };
      this.modalVisible = true;
    },
    async editarHora(id) {
      this.editandoId = id;
      try {
        const hora = await this.fetchHora(id);
        this.form = { ...hora.data };
      } catch (err) {
        this.error = getApiErrorMessage(err);
      }
      this.modalVisible = true;
    },
    async guardarHora() {
      this.cargandoForm = true;
      try {
        const data = { ...this.form };
        data.empleado = parseInt(data.empleado);
        data.recargo = parseInt(data.recargo);

        if (this.editandoId) {
          await this.actualizarHora({ id: this.editandoId, data });
        } else {
          await this.crearHora(data);
        }

        this.modalVisible = false;
        await this.cargarHoras();
      } catch (err) {
        this.error = getApiErrorMessage(err);
      } finally {
        this.cargandoForm = false;
      }
    },
    async eliminarHora(id) {
      if (!confirm('¿Estás seguro de que deseas eliminar este registro?')) {
        return;
      }
      try {
        await this.eliminarHora(id);
        await this.cargarHoras();
      } catch (err) {
        this.error = getApiErrorMessage(err);
      }
    },
    formatearFecha(fecha) {
      return fechaDeCalendario(fecha);
    },
  },
  mounted() {
    this.cargarHoras();
    this.cargarEmpleados();
  },
  watch: {
    'filtros.sin_liquidar': 'cargarHoras',
    'filtros.empleado': 'cargarHoras',
    'filtros.desde': 'cargarHoras',
    'filtros.hasta': 'cargarHoras',
  },
};
</script>

<style scoped>
.horas-home {
  padding: 1rem;
}

.header {
  margin-bottom: 1.5rem;
}

.filters {
  display: flex;
  gap: 1rem;
  align-items: flex-end;
  flex-wrap: wrap;
}

.filter-group {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.filter-group label {
  font-size: 0.875rem;
  font-weight: 500;
  color: #9e9e9e;
}

.filter-group input,
.filter-group select {
  padding: 0.5rem 0.75rem;
  min-width: 160px;
  background-color: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 6px;
  color: #f5f5f5;
  font-size: 0.95rem;
  transition: border-color 0.2s ease, background-color 0.2s ease;
}

.filter-group input:hover,
.filter-group select:hover {
  background-color: rgba(255, 255, 255, 0.09);
}

.filter-group input:focus,
.filter-group select:focus {
  outline: none;
  border-color: #2196f3;
  background-color: rgba(255, 255, 255, 0.09);
}

.filter-group select option {
  background-color: #1a1a1a;
  color: #f5f5f5;
}

.filter-group input[type="date"] {
  color-scheme: dark;
}

.filters > label {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  color: #d0d0d0;
  font-size: 0.9rem;
  padding-bottom: 0.6rem;
}

.loading {
  text-align: center;
  padding: 2rem;
  color: #9e9e9e;
}

.horas-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 1rem;
}

.horas-table thead {
  background-color: rgba(255, 255, 255, 0.04);
}

.horas-table th {
  padding: 1rem;
  text-align: left;
  font-weight: 600;
  color: #f5f5f5;
  border-bottom: 2px solid rgba(255, 255, 255, 0.16);
}

.horas-table td {
  padding: 1rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.horas-table tr:hover {
  background-color: rgba(255, 255, 255, 0.03);
}

.numero {
  text-align: right;
  font-family: 'Courier New', monospace;
}

.badge {
  display: inline-block;
  padding: 0.25rem 0.75rem;
  border-radius: 4px;
  font-size: 0.875rem;
  font-weight: 500;
}

.badge.liquidado {
  background-color: #d4edda;
  color: #155724;
}

.badge.pendiente {
  background-color: #fff3cd;
  color: #856404;
}

.acciones {
  text-align: center;
}

.btn-link {
  background: none;
  border: none;
  color: #1976d2;
  cursor: pointer;
  text-decoration: underline;
  padding: 0;
  font-size: 0.95rem;
  margin: 0 0.5rem;
}

.btn-link:hover {
  color: #1565c0;
}

.btn-primary {
  padding: 0.5rem 1rem;
  background-color: #1976d2;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.95rem;
  transition: background-color 0.2s;
}

.btn-primary:hover:not(:disabled) {
  background-color: #1565c0;
}

.btn-primary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-secondary {
  padding: 0.5rem 1rem;
  background-color: rgba(255, 255, 255, 0.08);
  color: #f5f5f5;
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.95rem;
}

.btn-secondary:hover {
  background-color: rgba(255, 255, 255, 0.14);
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.65);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal {
  background: #1e1e1e;
  color: #f5f5f5;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.4);
  max-width: 500px;
  width: 90%;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.modal-header h2 {
  margin: 0;
  font-size: 1.25rem;
}

.btn-close {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #9e9e9e;
}

.modal-body {
  padding: 1.5rem;
}

.form-group {
  margin-bottom: 1rem;
}

.form-group label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  font-size: 0.95rem;
}

.form-group input,
.form-group select,
.form-group textarea {
  width: 100%;
  padding: 0.5rem;
  background-color: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 4px;
  color: #f5f5f5;
  font-size: 0.95rem;
  font-family: inherit;
}

.form-group select option {
  background-color: #1a1a1a;
  color: #f5f5f5;
}

.form-group input[type="date"],
.form-group input[type="time"] {
  color-scheme: dark;
}

.form-group textarea {
  resize: vertical;
  min-height: 60px;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}

.modal-footer {
  display: flex;
  gap: 0.5rem;
  justify-content: flex-end;
  padding-top: 1rem;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
}

.error-alert {
  padding: 1rem;
  background-color: rgba(244, 67, 54, 0.12);
  border: 1px solid rgba(244, 67, 54, 0.4);
  border-radius: 4px;
  color: #ff8a80;
  margin-top: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.error-alert button {
  background: none;
  border: none;
  color: #ff8a80;
  cursor: pointer;
  text-decoration: underline;
}
</style>
